import { createGetAsyncSlice } from '@sonar-software/xuder';
import { getAllSalesforceOrganizationsByCustomer } from '../../../../api';

export const coreAllSalesforceOrganizationsByCustomerGetSlice = createGetAsyncSlice({
	name: 'CoreAllSalesforceOrganizationsByCustomer',
	receive: true,
	request: true,
	requestHandler: getAllSalesforceOrganizationsByCustomer,
	retainDataOnRequest: true
});
